document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".video-section .video");
  const popUpvideo = document.querySelectorAll(".popup_video");
  const videoLIs = document.querySelectorAll(".video-main .video-wrap");
  const playButtons = document.querySelectorAll(".play_button");
  const model = document.querySelector(".custom-model-main");
  const div = document.querySelector("#draggableDiv");
  const pdpVideo = document.querySelector("#pdp_video");
  const closeBtn = document.querySelector(".close-btn");
  const overlay = document.querySelector(".video_overlay");
  const closeBtnMob = document.querySelectorAll(".close-btn_mobile");
  const bgOverlay = document.querySelector(".bg-overlay");
  const shopBtn = document.querySelectorAll(".shop_button");
  const mutebtn = document.querySelectorAll(".volume_btn");
  let prev = document.getElementById("prevBtn");
    const pdppause_play = document.querySelector(".pause_play");
  const pdpclose = document.querySelector(".video-close");
  let next = document.getElementById("nextBtn");
  const popUpTitle = document.querySelector(
    ".pop-up-content-wrap .popup_video_title"
  );
  const videoContainer = document.querySelectorAll(".popup-video");
  // console.log('videos',videos)
    videos.forEach((video) => {
      
    const newThumbnail = video.getAttribute("poster").replace("_small", "");
  // console.log('videos',newThumbnail)
    const image = video.childNodes[1].setAttribute('loading','lazy')
    video.setAttribute("poster", newThumbnail);
    video.muted = true;
    video.addEventListener("click", openModel);
  });
  function muteAll() {
    popUpvideo.forEach((video) => {
      video.muted = true;
        // Add event listener for mouseenter
  video.addEventListener('mouseenter', () => {
    video.play(); // Play the video on mouse enter
  });
    });
    mutebtn.forEach((btn) => {
      btn.classList.remove("muted");
    });
  }
    if(pdpclose){
    pdpclose.onclick = function () {
      
    div.remove()
    }
  }
    if(pdppause_play){
    pdppause_play.onclick = function () {
      // console.log("clicked")
      if(pdpVideo.paused){
        pdpVideo.play()
        pdpVideo.muted = false;
        pdppause_play.querySelector(".icon.pause").classList.remove("hide")
        pdppause_play.querySelector(".icon.play").classList.add("hide")
        
      } else{
        pdppause_play.querySelector(".icon.play").classList.remove("hide")
        pdppause_play.querySelector(".icon.pause").classList.add("hide")
         pdpVideo.pause()
      }
    }
  }
  if (prev) {
    prev.addEventListener("click", function () {
      var currentIndex = Array.from(videoContainer).findIndex((video) =>
        video.classList.contains("active")
      );
      videoContainer[currentIndex].classList.remove("active", "paused");
      videoContainer[currentIndex].querySelector(".popup_video").pause();
      muteAll();
      currentIndex =
        (currentIndex - 1 + videoContainer.length) % videoContainer.length;
      videoContainer[currentIndex].classList.add("active");
      setTimeout(() => {
        videoContainer[currentIndex].querySelector(".popup_video").play();
        videoContainer[currentIndex].querySelector(
          ".popup_video"
        ).muted = false;
      }, 500);
    });
  }
  if (next) {
    next.addEventListener("click", function () {
      var currentIndex = Array.from(videoContainer).findIndex((video) =>
        video.classList.contains("active")
      );
      videoContainer[currentIndex].classList.remove("active", "paused");
      videoContainer[currentIndex].querySelector(".popup_video").pause();
      muteAll();
      currentIndex = (currentIndex + 1) % videoContainer.length;
      videoContainer[currentIndex].classList.add("active");
      setTimeout(() => {
        videoContainer[currentIndex].querySelector(".popup_video").play();
        videoContainer[currentIndex].querySelector(
          ".popup_video"
        ).muted = false;
      }, 500);
    });
  }
  // const header = document.querySelector("#shopify-section-header");

  popUpvideo.forEach((video) => {
    video.onclick = function () {
      if (video.paused) {
        video.play();
        video.parentNode.classList.remove("paused");
      } else {
        video.pause();
        video.parentNode.classList.add("paused");
      }
    };
  });
  mutebtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      muteFunction(btn);
    });
  });

  function muteFunction(clickedButton) {
    let popUpvdo = document.querySelector(".popup-video.active .popup_video");
    // console.log("popUpvdo", popUpvdo, clickedButton);
    // Rest of your mute functionality
    if (clickedButton.classList.contains("muted") && popUpvdo.muted == true) {
      clickedButton.classList.remove("muted");
    }
    popUpvdo.muted = !popUpvdo.muted;
    if (popUpvdo.muted == true) {
      clickedButton.classList.add("muted");
    }
  }
  function closeModel() {
    model.classList.remove("model-open");
    let popUpvdo = document.querySelector(".popup-video.active .popup_video");
    popUpvdo.pause();
    // header.style.zIndex = "3";
    if (div) {
      div.classList.remove("hide");
      pdpVideo.play();
    }
  }
  if(closeBtn){
    
  closeBtn.addEventListener("click", closeModel);
  }
  closeBtnMob.forEach((btn) => {
    btn.addEventListener("click", closeModel);
  });
  if(bgOverlay){
    
  bgOverlay.addEventListener("click", closeModel);
  }

  function openModel() {
    if (!document.body.classList.contains("template-product")) {
      let targeted = document.querySelector(
        `.video[data-video="${this.getAttribute("data-video")}"]`
      );

      if (targeted) {
        videoContainer.forEach((ele) => {
          ele.classList.remove("active", "paused");
        });
        let popUpvideomain = document.querySelector(
          `.popup-video[data-id="${this.getAttribute("data-video")}"]`
        );
        // console.log(popUpvideomain);
        popUpvideomain.classList.add("active");
        targeted.pause();
        // header.style.zIndex = "1";

        playVideoWithDelay(popUpvideomain.querySelector(".popup_video"));
      }
    }
  }
  function playVideoWithDelay(video) {
    setTimeout(() => {
      video.load();
      video.play();
      model.classList.add("model-open");
      if (div) {
        div.classList.add("hide");
      }
    }, 1500);
    video.muted = false;
  }
  function pdpPopUp() {

    pdpVideo.pause();
    document.querySelector(".popup-video").classList.remove("paused");
    document.querySelector(".volume_btn").classList.remove("muted");
    document.querySelector(".popup-video").classList.add("active");
    playVideoWithDelay(document.querySelector(".popup_video"));
  }

  if (pdpVideo) {
    pdpVideo.addEventListener("click", pdpPopUp);
  }

  playButtons.forEach((btn) => {
    btn.addEventListener("click", openModel);
  });

  shopBtn.forEach((btn) => {
    btn.addEventListener("click", openModel);
  });

  function handleMouseEnter(li) {
    const hoveredVideo = li.querySelector(".video");
    const videoTitle = li.querySelector(".video_title_wrap");
    const hideOnHover = li.querySelectorAll(".hide_hover");
    const allhideOnHover = document.querySelectorAll(".hide_hover");
    const allvideoTitle = document.querySelectorAll(".video_title_wrap");

    allvideoTitle.forEach((ele) => {
      requestAnimationFrame(() => ele.classList.add("active"));
    });

    allhideOnHover.forEach((ele) => {
      requestAnimationFrame(() => ele.classList.add("active"));
    });

    videos.forEach((video) => {
      video.pause();
    });

    hideOnHover.forEach((ele) => {
      if (ele.classList.contains("active")) {
        requestAnimationFrame(() => ele.classList.remove("active"));
      }
    });

    if (videoTitle) {
      setTimeout(
        () =>
          requestAnimationFrame(() => videoTitle.classList.remove("active")),
        600
      );
    }
    if(hoveredVideo){
      
    hoveredVideo.play();
    }
  }

  function handleMouseOut(li) {
    const videoTitle = li.querySelector(".video-main .video_title_wrap");
    const hideOnHover = li.querySelectorAll(".hide_hover");

    hideOnHover.forEach((ele) => {
      if (!ele.classList.contains("active")) {
        requestAnimationFrame(() => ele.classList.add("active"));
      }
    });

    if (videoTitle) {
      requestAnimationFrame(() => videoTitle.classList.add("active"));
    }
  }

  videoLIs.forEach((li) => {
    li.addEventListener("click", openModel);
    li.addEventListener("mouseenter", () => handleMouseEnter(li));
    li.addEventListener("mouseout", () => handleMouseOut(li));
  });

// Get references to all slider containers
const sliderContainers = document.querySelectorAll('.popup-video .video-main');

// Get references to all previous and next buttons
const prevButtons = document.querySelectorAll('.content_element .prev-next-button--prev');
const nextButtons = document.querySelectorAll('.content_element .prev-next-button--next');

// Add event listeners to all previous buttons
prevButtons.forEach((prevButton, index) => {
    prevButton.addEventListener('click', function() {
        let productListInner = document.querySelector('.popup-video.active .video-main');
        productListInner.scrollBy({ left: -(productListInner.clientWidth), behavior: "smooth" });
    });
});

// Add event listeners to all next buttons
nextButtons.forEach((nextButton, index) => {
    nextButton.addEventListener('click', function() {
  let productListInner = document.querySelector('.popup-video.active .video-main');
        productListInner.scrollBy({ left: productListInner.clientWidth, behavior: "smooth" });
    });
});



});
